import { h } from 'preact'
import * as firebase from 'firebase'
import FirebaseComponent from './FirebaseComponent'
import moment from 'moment'
import './UserLastLogin.css'

class UserLastLogin extends FirebaseComponent {
  constructor() {
		super()

    firebase.database().ref(`accounts/${this.state.uid}/connections/lastOnline`)
      .on('value', snapshot => {
        const date = snapshot.val()
        const lastOnline = moment(date).format('dddd, MMMM Do YYYY');

        this.setState({ lastOnline })
      })
  }

  render() {
    return (
      <div className="user-last-login-section">
        <span>You last logged in on </span>
        <span className="user-last-login-date">{this.state.lastOnline}</span>
      </div>
    );
  }
}

export default UserLastLogin



// WEBPACK FOOTER //
// ./src/UserLastLogin.js